import { useCallback, useEffect, useState } from "react";
import * as ExpoDocumentPicker from "expo-document-picker";

export type DocumentPickerProps = {
  isOpened: boolean;
  onClose: (documentUri?: string) => void;
  type: string;
};

export function DocumentPicker(props: DocumentPickerProps) {
  const pickImage = useCallback(async () => {
    // No permissions request is necessary for launching the image library
    const result = await ExpoDocumentPicker.getDocumentAsync({
      type: ["image/*", "application/pdf"],
    });

    if (!result.canceled) {
      props.onClose(result.assets[0].uri);
    } else {
      props.onClose();
    }
  }, [props.type]);

  useEffect(() => {
    if (props.isOpened) {
      pickImage();
    }
  }, [pickImage, props.isOpened]);

  return null;
}
